module.exports = __webpack_public_path__ + "img/sj_bancai.1fbbe354.jpg";